import React from "react";

// components
import NavigationBack from "components/NavigationBack";

export const EmptyData: React.FC = () => {
  return <div className="screen-libraries-product">
    <div className="libraries-description" style={{ height: "calc(100vh + 6rem)" }}>
      <div className="wrapper relative">
        <NavigationBack label="Back" url="/libraries" />
        <h1 className="libraries-description__cat-number text-align-cn">Library doesn’t exist</h1>
      </div>
    </div>
  </div>;
};

export default EmptyData;
